import { render, staticRenderFns } from "./userStatistics.vue?vue&type=template&id=9f8f5c04&scoped=true&"
import script from "./userStatistics.vue?vue&type=script&lang=js&"
export * from "./userStatistics.vue?vue&type=script&lang=js&"
import style0 from "./userStatistics.vue?vue&type=style&index=0&id=9f8f5c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8f5c04",
  null
  
)

export default component.exports